import React from 'react';
import Button from '../common/Button';

const ReportControls = ({
  reportType,
  setReportType,
  selectedYear,
  setSelectedYear,
  selectedMonth,
  setSelectedMonth,
  onRefresh,
  isLoading,
  doctors,
  selectedDoctor,
  setSelectedDoctor,
  canSelectDoctor = true,
  showGeneralDoctorOption = false,
  locations,
  selectedLocation,
  setSelectedLocation,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
  const months = [
    { value: 1, name: 'Enero' },
    { value: 2, name: 'Febrero' },
    { value: 3, name: 'Marzo' },
    { value: 4, name: 'Abril' },
    { value: 5, name: 'Mayo' },
    { value: 6, name: 'Junio' },
    { value: 7, name: 'Julio' },
    { value: 8, name: 'Agosto' },
    { value: 9, name: 'Septiembre' },
    { value: 10, name: 'Octubre' },
    { value: 11, name: 'Noviembre' },
    { value: 12, name: 'Diciembre' }
  ];

  return (
    <div className="reports-controls">
      <div className="control-group">
        <label>Tipo de Reporte:</label>
        <select 
          value={reportType} 
          onChange={(e) => setReportType(e.target.value)}
          className="form-select"
        >
          <option value="daily">Diario (por mes)</option>
          <option value="monthly">Mensual (por año)</option>
        </select>
      </div>

      {canSelectDoctor && (
      <div className="control-group">
        <label>Asignado a:</label>
        <select
          value={selectedDoctor}
          onChange={(e) => setSelectedDoctor(e.target.value)}
          className="form-select"
        >
          <option value="all">Todos</option>
          {showGeneralDoctorOption && (
            <option value="general">Venta General</option>
          )}
          {doctors && doctors.map(doctor => (
            <option key={doctor.id} value={doctor.id}>
              {doctor.name || doctor.email}
            </option>
          ))}
        </select>
      </div>
      )}

      {locations && locations.length >= 2 && setSelectedLocation && (
        <div className="control-group">
          <label>Ubicación:</label>
          <select
            value={selectedLocation || 'all'}
            onChange={(e) => setSelectedLocation(e.target.value)}
            className="form-select"
          >
            <option value="all">Todas</option>
            {locations.map(location => (
              <option key={location.id} value={location.id}>
                {location.name}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="control-group">
        <label>Año:</label>
        <select 
          value={selectedYear} 
          onChange={(e) => setSelectedYear(parseInt(e.target.value))}
          className="form-select"
        >
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      {reportType === 'daily' && (
        <div className="control-group">
          <label>Mes:</label>
          <select 
            value={selectedMonth} 
            onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
            className="form-select"
          >
            {months.map(month => (
              <option key={month.value} value={month.value}>{month.name}</option>
            ))}
          </select>
        </div>
      )}

      <Button 
        onClick={onRefresh}
        disabled={isLoading}
        className="refresh-btn"
        icon="fas fa-sync-alt"
      >
        Actualizar
      </Button>
    </div>
  );
};

export default ReportControls;
